import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Container } from "../style";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import staticNews from "../staticNews";
import "../main.css";

const AllNewsStyled = styled.div`
  padding: 20px 0;
  background-color: #f5f5f4;
`;

const NewsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
`;

const SectionTitle = styled.h2`
  font-size: 24px;
  margin-bottom: 20px;
`;

const Pagination = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-top: 20px;
`;

const PageButton = styled.button`
  padding: 8px 12px;
  font-size: 16px;
  border: 1px solid #ddd;
  background-color: ${(props) => (props.active ? "#007bff" : "#fff")};
  color: ${(props) => (props.active ? "#fff" : "#333")};
  border-radius: 4px;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  transition: background-color 0.3s, color 0.3s;

  &:hover:not(:disabled) {
    background-color: #e0e0e0;
  }
`;

const PageNumber = styled(PageButton)`
  min-width: 40px;
  text-align: center;
`;

function AllNews() {
  const { t, i18n } = useTranslation();
  const [dynamicNews, setDynamicNews] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const newsPerPage = 10;

  useEffect(() => {
    console.log("Fetching news for AllNews, page:", currentPage, "language:", i18n.language);
    fetch(`https://abt.tj/news-backend/api/news?page=${currentPage}&limit=${newsPerPage}&t=${Date.now()}`, {
      headers: { "X-API-Key": "2025" },
    })
      .then((res) => {
        if (!res.ok) throw new Error(`Failed to fetch news: ${res.status}`);
        return res.json();
      })
      .then((data) => {
        console.log("API Response (AllNews):", data);
        const formattedNews = data.news.map((item) => {
          const [day, month, year] = item.date.split(".");
          return {
            id: `api-${item.id}`,
            date: `${year}-${month}-${day}`,
            title: item.title[i18n.language] || item.title['ru'] || 'No title',
            path: `/news/${item.id}`,
          };
        });
        console.log("Formatted Dynamic News:", formattedNews);
        setDynamicNews(formattedNews);
        console.log("Total Pages:", data.totalPages);
        setTotalPages(data.totalPages || 1);
      })
      .catch((err) => {
        console.error("API Error (AllNews):", err.message);
        setDynamicNews([]);
        setTotalPages(1);
      });
  }, [currentPage, i18n.language]);

  // Нормализация статических новостей
  const formattedStaticNews = staticNews.map((item) => {
    let normalizedDate = item.date;
    if (item.date.includes("-") || item.date.includes(".")) {
      const [day, month, year] = item.date.split(/[-.]/);
      normalizedDate = `${year}-${month}-${day}`;
    }
    return {
      ...item,
      id: `static-${item.id}`,
      date: normalizedDate,
      title: item.titleKey ? t(item.titleKey) : item.title || 'No title',
    };
  });
  console.log("Formatted Static News:", formattedStaticNews);

  // Объединение и сортировка
  const allNews = [...formattedStaticNews, ...dynamicNews].sort((a, b) => {
    const dateA = new Date(a.date);
    const dateB = new Date(b.date);
    console.log(`Sorting: ${a.id} (${a.date}) vs ${b.id} (${b.date})`);
    return dateB - dateA;
  });
  console.log("All News (AllNews):", allNews);

  // Пагинация
  const startIndex = (currentPage - 1) * newsPerPage;
  const currentNews = allNews.slice(startIndex, startIndex + newsPerPage);
  console.log("Current News (AllNews):", currentNews);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      console.log("Changing page to:", page);
      setCurrentPage(page);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <AllNewsStyled>
      <Container>
        <SectionTitle>{t("allNews.title")}</SectionTitle>
        <NewsList>
          {currentNews.length === 0 ? (
            <p>No news available</p>
          ) : (
            currentNews.map(({ id, date, title, path }) => (
              <Link to={path} key={id}>
                <div className="news-item">
                  <div className="news-item__date">{date}</div>
                  <div className="news-item__text">{title}</div>
                </div>
              </Link>
            ))
          )}
        </NewsList>
        {totalPages > 1 && (
          <Pagination>
            <PageButton
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              {t("pagination.prev")}
            </PageButton>
            {[...Array(totalPages)].map((_, index) => {
              const page = index + 1;
              return (
                <PageNumber
                  key={page}
                  onClick={() => handlePageChange(page)}
                  active={currentPage === page}
                >
                  {page}
                </PageNumber>
              );
            })}
            <PageButton
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              {t("pagination.next")}
            </PageButton>
          </Pagination>
        )}
      </Container>
    </AllNewsStyled>
  );
}

export default AllNews;